<script setup lang="ts">
import type { PropType } from 'vue'
import HomeFloatingBoxDiamondHistory from '~/layers/homepage/components/box/HomeFloatingBoxDiamondHistory.vue'
import type { THomeSectionDiamondHistory } from '~/layers/homepage/data/types'

defineProps({
  section: {
    type: Object as PropType<THomeSectionDiamondHistory>,
    required: true,
  },
})
</script>

<template>
  <div class="main__picture">
    <URemotePicture :picture="section.picture" :isLazy="false" />
  </div>
  <HomeFloatingBoxDiamondHistory :section v-if="0" />
</template>
